<template>
  <v-container fluid grid-list-lg>
    <Create :createDialog="createDialog" @close="createDialog = false" @submit="getList"></Create>
    <EditMerchantDialog :editDialog="editDialog" :merchantObj="selectedMerchant" @close="editDialog = false" @submit="editMerchantSubmit"></EditMerchantDialog>
    <v-card :loading="loading" outlined>
      <ListTitle title="Merchant Accounts" :access="checkRightStatus(89)" @add="add" />
      <!-- <v-toolbar dense flat color="grey lighten-3">
        <v-app-bar-nav-icon @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>
        <v-toolbar-title>Merchant Accounts</v-toolbar-title>
      </v-toolbar> -->

      <v-card-title>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
              hide-details clearable></v-text-field>
          </v-col>

        </v-row>
      </v-card-title>
      <v-data-table class="pageHeight" :headers="headers" ref="myTable" :items="merchants" :search="search"
        :loading="loading" :sort-by="sortBy" :page.sync="page" hide-default-footer :items-per-page="itemsPerPage">
        <template v-slot:item="{ item }">
          <tr class="pointer">

            <td class="text-left">{{ item.createdAt | moment('MM/DD/YYYY') }}</td>

            <td class="text-left"> {{ item.name }} </td>

            


            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">

                  <v-list-item v-if="checkRightStatus(91)" @click="editMerchant(item)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>

                  <v-list-item v-if="checkRightStatus(92)" @click="deleteMerchant(item)">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>


            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import merchantService from "@/modules/Merchant/service.js";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
import EditMerchantDialog from './Edit.vue';
export default {
  name: "merchant-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedMerchant: null,
      headers: [
        {
          text: 'Create At',
          align: "left",
          value: "createdAt",
          sortable: true,
        },
        {
          text: 'Name',
          align: "left",
          value: "name",
          sortable: true,
        },
       
        {
          text: "",
          value: "action",
          sortable: false,
        }
      ],
      merchants: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "id",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Merchant List";
  },
  components: {
    Create,
    EditMerchantDialog,
    // ClassesDropbox,
    // AssignTeacher,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    editMerchantSubmit() {
      this.getList();
    },
    getList() {
      this.loading = true;
      this.editDialog = false
      this.createDialog = false

      return merchantService.getAll().then((response) => {
        console.log("response ", response)
        this.loading = false;
        this.merchants = response.data;
        this.itemsPerPage = this.merchants.length
      });
    },
    editMerchant(obj) {
      this.selectedMerchant = obj;
      this.editDialog = true;
    },
    deleteMerchant(Merchant) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to remove ${Merchant.name}. This will stop all the income payments.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          merchantService.delete(Merchant.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Merchant has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
